const Chart = require("../../Dashboard/Chart/chart");

const ChartDataLabels = require("chartjs-plugin-datalabels");

const DealsChart = React.createClass({
  render: function () {
    return <div>
      <div className="h-280 ovy-auto thinScrollbar">
        <Chart
          type="horizontalBar"
          plugins={[ChartDataLabels]}
          datasets={[
            {
              data: this.props.data.map(item => item.value),
              backgroundColor: "#06D051"
            }
          ]}
          labels={this.props.data.map(item => (
            item.name || "Indefinido"
          ))}
          options={{
            legend: false,
            onHover: this.props.onHover,
            onClick: this.props.onClick,
            scales: {
              xAxes: [{
                display: false,
                gridLines: {
                  display: false,
                  drawBorder: false
                },
                ticks: {
                  stepSize: 5
                }
              }],
              yAxes: [{
                gridLines: {
                  display: false,
                  drawBorder: false
                },
              }]
            },
            tooltips: {
              callbacks: {
                label: (tooltipItem) => {
                  return this.props.data[tooltipItem.index].count + " negócios";
                }
              }
            },
            plugins: {
              datalabels: {
                formatter: value => value + "%",
                anchor: "end",
                align: "end"
              }
            }
          }}
        />
      </div>
      <p className="text-muted fs-14">Participação por negócios</p>
    </div>
  }
})

module.exports = DealsChart;



// WEBPACK FOOTER //
// ./app/screens/Dashboard/components/Widgets/ProductsBestSellers/deals-chart.jsx